import { useRecoilState } from "recoil"
import { sizeState } from "../recoil-atom"

import { Flex } from "../styled-components-openmark"

const NotFound = () => {
  const [size, setSize] = useRecoilState(sizeState)

  return (
    <>
      <Flex center>
        <div className="error404" />
      </Flex>
      <style jsx>{`
        .error404 {
          width: ${size.appWidth * 0.5}px;
          height: ${size.appWidth * 0.5}px;
          background-image: url("/404.png");
          background-size: cover;
          background-position: center center;
        }
      `}</style>
    </>
  )
}

export default NotFound
